/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { Container, Row, Col } from 'reactstrap';
import { loginWithToken } from '../AuthService'
import * as default_data from '../config.js'
import { getBannerColor } from '../Utils/classification_helper.js';

function LossPass2Form() {
  const [loaded, setLoaded] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState('');

  var loaded_static = false;

  useEffect(() => {
    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    var token = searchParams.get("token")
    loginWithToken(token)
    setErrorMessage('Checking your token. If the page does not refresh, your token is invalid or has expired.')
    }, [])


  return (
    <div>
    { 
      <div className={`header-message ${getBannerColor(false)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'UNCLASSIFIED' 
        }
      </div>            
    }
    <div className="reg-page-mode">
    <Container>
      <Row className="justify-content-center reg-page-mode-header">
        <Col xs="12" md="12" lg="12">
        <a href="/"><img src="logo.png" alt="Ask Sage" /></a>
          <h1>Logging in to "Ask Sage"</h1>
        </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-content">
        <Col xs="12" md="8" lg="6">
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
            </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-footer">
        <Col xs="12" md="12" lg="12">
          Copyright &copy; {default_data.default_copywrite_year} Ask Sage, Inc.
        </Col>
      </Row>
    </Container>  
    </div>
    </div>
  );
}

export default LossPass2Form;
